<template>
  <div class="realtime-monitor-container flex h-full">
    <el-card class="w-300px flex-shrink-0 mr-10px h-full" :body-style="{ height: '100%' }">
      <TitleBorder title="摄像头列表">
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="iconfont icon-bg-more11 text-14px font-bold"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </TitleBorder>

      <div class="flex mb-10px">
        <el-select class="mr-10px flex-1" v-model="manufacturerCode" placeholder="类型归属">
          <el-option
            v-for="item in facturerList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-button type="primary" size="mini" class="!h-36px" @click="searchTreeData"
          >搜索</el-button
        >
      </div>
      <div>
        <el-input
          placeholder="区域名称/摄像头名称"
          prefix-icon="el-icon-search"
          v-model="treeKeyword"
          class="mb-10px"
          clearable
          @keyup.enter.native="searchTreeData"
        ></el-input>
      </div>

      <div v-loading="treeLoading" class="overflow-y-auto h-[calc(100%-100px)]">
        <!-- show-checkbox
          check-strictly
          check-on-click-node
          @check-change="checkChange" -->
        <el-tree
          v-if="treeShow"
          node-key="pr_code"
          ref="treeRef"
          :default-expand-all="defaultExpandAll"
          highlight-current
          :data="treeData"
          :filter-node-method="filterTreeNode"
          :props="defaultTreeProps"
          @node-click="handleNodeClick"
        >
          <div slot-scope="{ node, data }" class="node-item flex-1">
            <div class="custom-tree-node">
              <div :title="node.label" class="truncate">
                {{ node.label }}
              </div>
              <el-tooltip :content="filterStatus(data.status).text" placement="top">
                <i
                  class="el-icon-video-camera-solid"
                  :style="{ color: filterStatus(data.status).color }"
                ></i>
              </el-tooltip>
            </div>
          </div>
        </el-tree>
      </div>
    </el-card>
    <!-- 宇视 -->
    <YSMonitor v-if="manufacturerCode === 'UniView'" ref="ysMonitorRef"></YSMonitor>
    <!-- 大华 -->
    <DHWSMonitor ref="DHWSMonitorRef" v-if="manufacturerCode === 'DaHua'"></DHWSMonitor>
    <!-- 海康 WebControl方式则为四屏播放，否则为单屏播放 -->
    <template v-if="manufacturerCode === 'Hik'">
      <div class="flex-1 h-full flex flex-wrap" v-if="isWebControl">
        <div
          @click="currentMonitorIndex = index"
          v-for="(item, index) in currentMonitorList"
          :key="index"
          :style="{
            width: `calc(100% / ${_.ceil(Math.sqrt(currentMonitorList.length))})`,
            height: `calc(100% / ${_.ceil(Math.sqrt(currentMonitorList.length))})`,
            borderColor: currentMonitorIndex === index ? '#0000ff' : '#ccf31e',
          }"
          class="monitor-item"
        >
          <div class="flex flex-col h-full" v-if="item.code">
            <TitleBorder class="m-5px" :title="item.name || '实时监控画面'"></TitleBorder>
            <!-- webcontrol方式播放不支持的情况下使用h5播放,比如正宁现场是麒麟系统，不能安装播放插件，就不能采用上面方式播放 -->
            <HKPlayer
              v-if="notCanUseVideoWebPlugin"
              class="flex-1"
              :cameraIndexCode="item.code"
              :id="item.code"
              :showToolbar="1"
            ></HKPlayer>
            <!-- webcontrol方式播放 -->
            <HKWebControlPlayer
              v-else
              class="flex-1"
              :id="item.code"
              :cameraIndexCode="item.code"
              @downloadDialog="downloadDialog(index)"
            ></HKWebControlPlayer>
          </div>
          <div v-else class="flex-1 w-full flex justify-center items-center">
            暂无数据！
          </div>
        </div>
      </div>
      <HKMonitor v-else :cameraIndexCode="cameraCode" ref="hkMonitorRef"></HKMonitor>
    </template>
  </div>
</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import TitleBorder from '@/components/TitleBorder'
import devaspService from '@/services/pageService/devasp'
import HKWebControlPlayer from '@/components/video/HKPlayer/WebIndex'
import HKPlayer from '@/components/video/HKPlayer/index'
import _ from 'lodash'
import YSMonitor from './YSMonitor'
import DHWSMonitor from './DHWSMonitor'
import HKMonitor from './HKMonitor'

const iOTDeviceApi = new IOTDeviceApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  name: 'realTimeMonitor',
  components: {
    YSMonitor,
    DHWSMonitor,
    HKMonitor,
    HKWebControlPlayer,
    TitleBorder,
    HKPlayer,
  },
  data() {
    return {
      facturerList: [],
      manufacturerCode: '',
      treeKeyword: '',
      treeShow: true,
      treeLoading: false,
      defaultTreeProps: {
        children: 'children',
        label: 'pr_name',
        // label: 'name',
      },
      defaultExpandAll: false,
      treeData: [],
      monitorList: [],
      cameraCode: '', // 海康监控画面code
      currentMonitorList: [], // 当前显示的摄像头列表
      currentMonitorIndex: null, // dashboard 选择的摄像头序号
    }
  },
  computed: {
    isWebControl() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config.isWebControl'
      )
    },
    notCanUseVideoWebPlugin() {
      // 现场环境是否不支持使用插件方式
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config.notCanUseVideoWebPlugin'
      )
    },
  },
  watch: {
    treeKeyword(val) {
      val = val.replace(/(^\s*)|(\s*$)/g, '')
      this.$refs.treeRef.filter(val)
    },
  },
  methods: {
    /**
     * 监听是否安装海康播放器插件
     * 当用户未下载插件时，弹出弹框支持在线下载
     */
    downloadDialog(index) {
      if (this.isWebControl && index === 0) {
        // 第一个弹出提示，不用每个都弹出
        this.$confirm('插件启动失败，请检查插件是否安装或点击下载按钮进行下载!', '提示', {
          confirmButtonText: '下载',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            // 安装包放在服务器上
            window.location.href = '/static/hik/VideoWebPlugin.exe'
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下载',
            })
          })
      }
    },
    /**
     *
     * @description: 操作区域树是否展开全部
     * @param {*} bool
     * @return {*}
     */
    operateTree(bool) {
      this.treeShow = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeShow = true
      })
    },
    searchTreeData() {},
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    filterStatus(status) {
      switch (status) {
        case 1:
          return {
            color: 'green',
            text: '在线',
          }
          break
        case 2:
          return {
            color: 'red',
            text: '离线',
          }
          break
        default:
          return {
            color: 'gray',
            text: '未知',
          }
          break
      }
    },
    handleNodeClick(data) {
      console.log('data', data)
      if (this.manufacturerCode === 'UniView') {
        // 宇视
        if (data.code) {
          this.$refs.ysMonitorRef.playVideo(data)
        }
      } else if (this.manufacturerCode === 'Hik') {
        // 海康
        if (data.code) {
          if (this.isWebControl) {
            // 四屏播放
            // 判断当前点击的项目是否在监控列表中已经播放，如果播放弹出重新选择提示
            const isExist = _.find(this.currentMonitorList, ['id', data.id]) || {}
            if (!_.isEmpty(isExist)) {
              this.$message.warning('当前监控已存在，请重新选择!')
              return
            }
            if (!_.isNil(this.currentMonitorIndex)) {
              this.$set(this.currentMonitorList, this.currentMonitorIndex, data)
            }
            console.log('currentMonitorList', this.currentMonitorList)
          } else {
            // 单屏播放
            this.cameraCode = data.code
            this.$refs.hkMonitorRef.$children[0].$children[1].getWS()
          }
        }
      } else if (this.manufacturerCode === 'DaHua') {
        if (data.code) {
          this.$refs.DHWSMonitorRef.playVideo(data)
        }
      }
    },
    gridShowHandle(num) {
      this.monitorNum = num
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') {
            // 类型归属
            facturerList = item.dataItems
          }
        })

        const existIOTDeviceTypeList =
          Wiz.globalSettings.dynamicModules.modules['wiz-iot-management-tongre'].config
            ?.existIOTDeviceTypeList
        if (existIOTDeviceTypeList) {
          facturerList = facturerList.filter((item) => {
            return existIOTDeviceTypeList.includes(item.code)
          })
        }

        this.facturerList = facturerList
        if (facturerList.length) {
          const code =
            Wiz.globalSettings.dynamicModules.modules['wiz-iot-management-tongre'].config
              .defaultCode || 'UniView'
          facturerList.forEach((item) => {
            if (item.code === code) {
              this.manufacturerCode = code
            }
          })
          if (!this.manufacturerCode) {
            this.manufacturerCode = facturerList[0].code
          }
        }
      }
    },
    // 获取区域
    async getAera() {
      // 是否不获取区域数据
      const isNotGetArea = _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config.isNotGetArea'
      )
      if (isNotGetArea) {
        this.treeData = this.monitorList
      } else {
        this.treeLoading = true
        try {
          const [err, res] = await devaspService.getAera({
            token: 'portal_js',
          })
          if (!err) {
            const areaTree = this.unflatten([...res.data.items, ...this.monitorList])
            this.treeData = areaTree
          } else {
            this.treeData = this.monitorList
          }
          this.treeLoading = false
        } catch (e) {
          this.treeData = this.monitorList
          this.treeLoading = false
        }
      }

      /** 获取监控配置列表 - 四条 */
      if (this.isWebControl) {
        this.flattenTree(this.treeData, this.currentMonitorList)
        if (this.currentMonitorList.length < 4) {
          const fillList = new Array(4 - this.currentMonitorList.length).fill({
            code: '',
          })
          this.currentMonitorList.push(...fillList)
        }
        console.log('currentMonitorList', this.currentMonitorList)
      }
      const isUseNewYS =
        _.get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config')
          ?.NewYSPlayerConfig?.isUseNewYS || false
      if (isUseNewYS && !_.isEmpty(this.treeData)) {
        this.$nextTick(() => {
          this.$refs?.treeRef?.setCurrentKey(this.treeData[0].pr_code)
          this.handleNodeClick(this.treeData[0])
          this.$refs?.ysMonitorRef?.setMonitorList(this.treeData)
        })
      }
      console.log('isUseNewYS', isUseNewYS)
    },
    flattenTree(data, resList = []) {
      _.forEach(data, (item) => {
        if (item.code && resList.length < 4) {
          resList.push(item)
        }
        if (item?.children?.length) {
          this.flattenTree(item.children, resList)
        }
      })
    },
    // 数组转树
    unflatten(data, rootId = null, dataKey = 'pr_code', parentKey = 'pr_preentcode') {
      const tree = []
      const childrenMap = {}
      for (let i = 0; i < data.length; i += 1) {
        const item = { ...data[i] }
        const id = item[dataKey]
        const parentId = item[parentKey]

        if (Array.isArray(item.children)) {
          childrenMap[id] = item.children.concat(childrenMap[id] || [])
        } else if (!childrenMap[id]) {
          childrenMap[id] = []
        }
        item.children = childrenMap[id]

        if (parentId !== undefined && parentId !== rootId && parentId) {
          if (!childrenMap[parentId]) childrenMap[parentId] = []
          childrenMap[parentId].push(item)
        } else {
          tree.push(item)
        }
      }
      return tree
    },
    // 获取摄像头列表
    async getMonitorList() {
      const [err, res] = await iOTDeviceApi.getDeviceWithDetailPageList({
        skipCount: 0,
        maxResultCount: 9999,
      })
      if (!err) {
        res.items.forEach((item) => {
          item.pr_code = item.code
          item.pr_name = item.name
          item.pr_preentcode = item.areaCode
        })
        this.monitorList = res.items
        this.getAera()
      }
    },
  },
  created() {
    this.getCategoryByCodes()
    this.getMonitorList()
  },
  deactivated() {
    this.manufacturerCode = ''
  },
}
</script>

<!-- 一加 /deep/ 编译就报错 -->
<style scoped lang="scss">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.monitor-item {
  border: 1px solid #ccf31e;
}
</style>
<!-- <style lang="scss">
.realtime-monitor-container {
  .el-tree {
    .el-tree-node {
      .is-leaf + .el-checkbox .el-checkbox__inner {
        display: inline-block;
      }
      .el-checkbox .el-checkbox__inner {
        display: none;
      }
    }
  }
}
</style> -->
